import React from "react"
import ReactMarkdown from "react-markdown"
import { BgImage } from "gbimage-bridge"
import { graphql, Link } from "gatsby"
import { GatsbyImage, getSrc } from "gatsby-plugin-image";
// import { Link } from "gatsby"
import TopMenu from "../components/TopMenu"
import BookDemo from "../components/BookDemo"
import Footer from "../components/Footer"
import {
  MdZoomIn,
} from "react-icons/md"
import Seo from "../components/Seo"
import Testimonial from "../components/testimonials/Testimonial"
// import BookDemoButton from "../components/BookDemoButton"
import VideoButton from "../components/VideoButton"

// import LayoutGeneric from "../components/LayoutGeneric"

export default function ProductOcus40({data}) {
  // let [state, setState] = React.useState({ selectedFeature: 0 });

  const { 
    image, title, subtitle, descriptionShort, 
    description, imageAlt1, imagePack, features, scans, SEO,
    videoCodeOverview, videoCodeUnboxing, bookDemo
  } = data.strapiProducts;
  // console.log(data);

  // function prodFeatureClick(num){
  //   setState({ selectedFeature: num });
  //   // console.log(num);
  // }

  return (
    <div className="">
      <Seo 
      title={(SEO && SEO.title) ? SEO.title : title}
      description={(SEO && SEO.description) ? SEO.description : descriptionShort}
      />
      <BgImage image={image.childImageSharp.gatsbyImageData} className="gs-bg-parallax"></BgImage>
      <TopMenu/>
      <div className="gs-page">

        <div className="gs-bg-parallax__wrap">

          
        <div className="gs-prod-hero">
            <div className="gs-prod-features">
              <div className="gs-sect__in gs-container">
                <div className="gs-prod-hero-columns">
                  <header className="gs-prod-header">
                      <h1 className="gs-header-msg--mark">{title}</h1>
                      <div className="gs-products-item__hr"></div>
                      <h3 className="fw300">{subtitle}</h3>
                    <p className="mb2">{descriptionShort}</p>
                    {/* <BookDemoButton className="mrb1"/> */}
                    <Link to="/book" className="gs-button gs-color-contrast mr1 mb1">
                      Book a demo
                    </Link>
                    {
                      videoCodeOverview && <VideoButton youtubeId={videoCodeOverview}>WATCH VIDEO</VideoButton>
                    }
                  </header>
    
                  <div className="gs-prod-features-device">
                    <div className="gs-prod-features-device__shadow gs-prod-features-device__shadow--40"></div>
                    <GatsbyImage
                      image={imageAlt1.childImageSharp.gatsbyImageData}
                      alt="Grundium Ocus"
                      className="gs-prod-features-device__pic" />
                    {/* <Image fluid={productImage.childImageSharp.fluid} alt="Grundium Ocus" className="gs-prod-features-device__pic"/> */}
    
                    {/* {
                      productFeatures.map((feature) => {
                        let classes = "gs-prod-features-point gs-prod-features-point--"+ feature.id + (state.selectedFeature === feature.id ? " gs-prod-features-point--active" : "");
                        return <div  key={feature.id} className={classes} onClick={() => prodFeatureClick(feature.id)}>
                        <MdAddCircle/>
                        </div>
                      })
                    } */}
                  </div>
                </div>
              <div className="gs-prod-features-list">
                {
                  features.map((feature) => {
                    // let classes = "gs-prod-features-box" + (state.selectedFeature === feature.id ? " gs-prod-features-box--active" : "");
                    // console.log(feature, classes)
                    return( 
                    // <div key={feature.id} className={classes} data-box={feature.id} onClick={() => prodFeatureClick(feature.id)}>
                    <div key={feature.id} className="gs-prod-features-box" data-box={feature.id}>
                      <img src={feature.icon?.publicURL} className="gs-prod-features-box__icon" alt={feature.name}></img>
                      <div className="gs-prod-features-box__text">
                      <h3 className="gs-prod-features-box__title">{feature.name}</h3>
                        <p className="gs-features-item__caption">{feature.desc}</p>
                      </div>
                    </div>
                    )
                  })
                }
              </div>
            </div>
          </div>

          </div>

        <section className="gs-prod-description gs-products-item">
          <div className="gs-sect__in gs-container ovh">
              <div className="gs-page-content">
              <ReactMarkdown source={description} linkTarget="_blank"/>

              {
                Boolean(scans.length) && (
                  <div className="gs-prod-scans mb2">
                    <h2>SCANNED REFERENCE IMAGES</h2>
                    <div className="gs-prod-scans-list">
                      {
                        scans.map((scan) => {
                          // console.log(feature, classes)
                          return (
                            <div key={scan.id} className="gs-prod-scans-item tac">
                              <a href={scan.link} target="_blank" rel="noreferrer" className="gs-prod-scans-item__link">
                                <div className="gs-prod-scans-item__pic">
                                  <MdZoomIn className="gs-prod-scans-item__icon" />
                                  <img src={getSrc(scan.thumbNail)} className="gs-prod-scans-item__img"  alt={scan.name}/>
                                </div>
                                <h4 className="gs-prod-scans-item__title fw300">{scan.name}</h4>
                              </a>
                            </div>
                          );
                        })
                      }
                    </div>
                  </div>
                  )
                }

                <h2>SALES PACKAGE CONTENT</h2>
                <div className="posr">
                {
                  videoCodeUnboxing && <VideoButton youtubeId={videoCodeUnboxing} className="gs-video-button--abs">UNBOXING</VideoButton>
                }
                <GatsbyImage image={imagePack.childImageSharp.gatsbyImageData} className="mb1" alt="Sales package content" />
                <div className="tac">The carry-on travel case sold separately</div>
                </div>
              </div>
          </div>
        </section>
        <section className="gs-products-item gs-products-item--2">
          <div className="gs-sect__in gs-container ovh">
            <Testimonial selected={9}></Testimonial>
          </div>
        </section>

        <BookDemo
          title={bookDemo.title}
          text={bookDemo.text}
          cta={bookDemo.buttonText}
        />

        <Footer />

        </div>
        </div>
      </div>
  );
}

export const query = graphql`{
  strapiProducts(slug: {eq: "ocus40"}) {
    description
    slug
    subtitle
    title
    descriptionShort
    SEO {
      title
      description
    }
    image {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
      }
    }
    imageAlt1 {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
      }
    }
    imagePack {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
      }
    }
    videoCodeOverview
    videoCodeUnboxing
    features {
      id
      desc
      name
      icon {
        publicURL
      }
    }
    scans {
      id
      link
      name
      thumbNail {
        childImageSharp {
          gatsbyImageData(width: 270, placeholder: BLURRED, layout: CONSTRAINED)
        }
      }
    }
    bookDemo {
      title
      text
      buttonText
    }
  }
}
`;
// export const query = graphql`
//   {
//     strapiPageOcus {
//       slug
//       title
//       subtitle
//       productFeatures {
//         id
//         desc
//         name
//         icon {
//           publicURL
//         }
//       }
//       productImage {
//         childImageSharp {
//           fluid(maxWidth: 2000) {
//             ...GatsbyImageSharpFluid
//           }
//         }
//       }
//       image {
//         childImageSharp {
//           fluid(maxWidth: 2000) {
//             ...GatsbyImageSharpFluid
//           }
//         }
//       }
//       heroText
//       content
//     }
//   }
// `;
